import select from './DepartmentSelect.vue'
const DepartmentSelect = {
	install: function(Vue) {
		Vue.component('DepartmentSelect', select)
	}
}
export default DepartmentSelect
